import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { PlusIcon } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import * as yup from 'yup';

import { FormUnsavedConfirmationWrapper } from '../../../../components/pages/backoffice/form-unsaved-confirmation-wrapper.jsx';
import CancelButton from '../../../../components/buttons/cancel-button.jsx';
import Heading from '../../../../components/typography/heading.jsx';
import { Button } from '../../../../components/ui/button.jsx';
import FormCard from '../../../../components/ui/form-card.jsx';
import FormFooter from '../../../../components/ui/form-footer.jsx';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../components/ui/form.jsx';
import { Input } from '../../../../components/ui/input.jsx';
import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';
import { queryClient } from '../../../../services/query/client.js';

export function EligibilityWatchlistCreate() {
  const navigate = useNavigate();

  const formCreateEligibilityWatchlist = useForm({
    defaultValues: {
      name: undefined,
      identificationDoc: undefined,
      shop: undefined,
    },
    resolver: yupResolver(
      yup.object().shape({
        name: yup
          .string()
          .min(4, 'Nome tem de ter pelo menos 4 caracteres')
          .max(60, 'Nome não pode ultrapassar 60 caracteres')
          .required('Nome é um campo obrigatório'),
        shop: yup.string().required('Loja é um campo obrigatório'),
      }),
    ),
  });

  const mutationCreateEligibilityWatchlist = useMutation({
    mutationFn: async (data) => {
      const { data: newEligibilityWatchlistRes } = await msCatalystApi.post(
        `/eligibility-watchlist`,
        data,
      );
      return newEligibilityWatchlistRes.data;
    },
    onSuccess: (data) => {
      toast.success('Funcionário Interno / Loja criado(a) com successo!');
      queryClient.setQueryData(['eligibility-watchlist'], data);

      navigate(`/backoffice/admin/employees/${data.ROWID}`);
    },
    onError: (err) => {
      if (err?.response?.data) {
        toast.error(
          `Erro ao criar Funcionário Interno / Loja: ${err.data.message}`,
          {
            description: 'Tente novamente mais tarde',
          },
        );
      } else {
        toast.error('Erro ao criar Funcionário Interno / Loja', {
          description: 'Tente novamente mais tarde',
        });
      }
    },
  });

  const onFormSubmit = async (data) => {
    mutationCreateEligibilityWatchlist.mutate(data);
  };

  return (
    <FormUnsavedConfirmationWrapper form={formCreateEligibilityWatchlist}>
      <Heading className="pb-6">Criar Funcionário Interno / Loja</Heading>

      <Form {...formCreateEligibilityWatchlist}>
        <form
          onSubmit={formCreateEligibilityWatchlist.handleSubmit(onFormSubmit)}
        >
          <div className="flex flex-col space-y-10">
            <FormCard>
              <FormField
                control={formCreateEligibilityWatchlist.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Nome</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={formCreateEligibilityWatchlist.control}
                name="identificationDoc"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Nº Identificação</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={formCreateEligibilityWatchlist.control}
                name="shop"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Loja</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </FormCard>
          </div>

          <FormFooter>
            <CancelButton />
            <Button
              type="submit"
              disabled={
                formCreateEligibilityWatchlist.formState.isSubmitting ||
                !formCreateEligibilityWatchlist.formState.isDirty
              }
              isLoading={formCreateEligibilityWatchlist.formState.isSubmitting}
            >
              <PlusIcon />
              Criar
            </Button>
          </FormFooter>
        </form>
      </Form>
    </FormUnsavedConfirmationWrapper>
  );
}
